import CheckboxAttribute from 'Components/attributes/CheckboxAttribute/Checkbox'
import MultiTextAttribute from 'Components/attributes/MultiTextAttribute/MultiText'
import RadioButtonAttribute from 'Components/attributes/RadioButtonAttribute/RadioButton'
import SliderRatingAttribute from 'Components/attributes/RatingsAttribute/SliderRating'
import SelectAttribute from 'Components/attributes/SelectAttribute/Select'
import SliderAttribute from 'Components/attributes/SliderAttribute/Slider'
import TextAreaAttribute from 'Components/attributes/TextAreaAttribute/TextArea'
import {
    AttributeValueType,
    BaseAttributePropsType,
    CheckboxAttributeProps,
    DateAttributeProps,
    FileAttributeProps,
    MarkdownAttributeProps,
    MultiTextAttributeProps,
    NumberAttributeProps,
    RadioButtonAttributeProps,
    RichTextAttributeProps,
    SelectAttributeProps,
    SliderAttributeProps,
    SliderRatingAttributeProps,
    TextAreaAttributeProps,
    TimeAttributeProps,
} from 'Types/Attribute.types'
import { TaskAttribute } from 'Types/Tasks.types'
import DateAttribute from 'Components/attributes/DateAttribute/Date.tsx'
import TimeAttribute from 'Components/attributes/TimeAttribute/Time.tsx'
import NumberAttribute from 'Components/attributes/NumberAttribute/Number.tsx'
import FileAttribute from 'Components/attributes/FileAttribute/File'
import RichTextAttribute from 'Components/attributes/RichTextAttribute/RichTextAttribute'
import MarkdownAttribute from 'Components/attributes/MarkdownAttribute/MarkdownAttribute'

export type AttributesFactoryProps = {
    value: AttributeValueType
    config: TaskAttribute
    className: string
    onChange: (value: AttributeValueType, name: string) => void
    readonly?: boolean
}

export const AttributesFactory = (props: AttributesFactoryProps) => {
    const commonProps: BaseAttributePropsType<AttributeValueType> = {
        id: props.config.attribute_id,
        value: props.value,
        className: props.className,
        onChange: (value: AttributeValueType) => props.onChange(value, props.config.name),
        readonly: props.readonly,
        width: '100%',
    }
    switch (props.config.input_definition?.input_type) {
        case 'SELECT':
            switch (props.config?.input_definition.component_type) {
                case 'DROPDOWN':
                    return (
                        <SelectAttribute
                            {...({
                                ...commonProps,
                                options: props.config.input_definition.options,
                            } as SelectAttributeProps)}
                        />
                    )
                case 'RADIO_BUTTON':
                    return (
                        <RadioButtonAttribute
                            {...({
                                ...commonProps,
                                options: props.config.input_definition.options,
                            } as RadioButtonAttributeProps)}
                        />
                    )
                case 'SLIDER':
                    return (
                        <SliderRatingAttribute
                            {...({
                                ...commonProps,
                                options: props.config.input_definition.options,
                            } as SliderRatingAttributeProps)}
                        />
                    )
            }
            break
        case 'MULTI_SELECT':
            switch (props.config?.input_definition.component_type) {
                case 'DROPDOWN':
                    return (
                        <SelectAttribute
                            {...({
                                ...commonProps,
                                options: props.config.input_definition.options,
                                mode: 'multiple',
                            } as SelectAttributeProps)}
                        />
                    )
                case 'CHECKLIST':
                    return (
                        <CheckboxAttribute
                            {...({
                                ...commonProps,
                                options: props.config.input_definition.options,
                            } as CheckboxAttributeProps)}
                        />
                    )
            }
            break
        case 'TEXT':
            return (
                <TextAreaAttribute
                    {...({
                        ...commonProps,
                        placeholder: props.config.input_definition.placeholder,
                        rows: 4,
                    } as TextAreaAttributeProps)}
                />
            )
        case 'INT_SCALE':
            return (
                <SliderAttribute
                    {...({
                        ...commonProps,
                        min: props.config.input_definition.min,
                        max: props.config.input_definition.max,
                        step: props.config.input_definition.interval,
                    } as SliderAttributeProps)}
                />
            )
        case 'STRING_ARRAY':
            return (
                <MultiTextAttribute
                    {...({
                        ...commonProps,
                    } as MultiTextAttributeProps)}
                />
            )
        case 'DATE':
            return (
                <DateAttribute
                    {...({
                        ...commonProps,
                    } as DateAttributeProps)}
                />
            )
        case 'TIME':
            return (
                <TimeAttribute
                    {...({
                        ...commonProps,
                    } as TimeAttributeProps)}
                />
            )
        case 'INT':
            return (
                <NumberAttribute
                    {...({
                        ...commonProps,
                    } as NumberAttributeProps)}
                />
            )
        case 'FILE':
            return (
                <FileAttribute
                    {...({
                        ...commonProps,
                        maxSizeInGB: props.config.input_definition.max_size_in_gb,
                    } as FileAttributeProps)}
                />
            )
        case 'RICH_TEXT':
            return (
                <RichTextAttribute
                    {...({
                        ...commonProps,
                        grammar: {
                            isEnabled: props.config.input_definition.grammar.is_enabled,
                            customDictionaryId:
                                props.config.input_definition.grammar.custom_dictionary_id,
                            lang: props.config.input_definition.grammar.lang,
                            proofreadDialog: props.config.input_definition.grammar.proofread_dialog,
                            settings: props.config.input_definition.grammar.settings,
                        },
                    } as RichTextAttributeProps)}
                />
            )
        case 'MARKDOWN':
            return <MarkdownAttribute {...(commonProps as MarkdownAttributeProps)} />
        // case ATTRIBUTE_TYPES.SELECT:
        //     return <SelectAttribute {...(props as SelectAttributeProps)} />
        // case ATTRIBUTE_TYPES.SLIDER:
        //     return <SliderAttribute {...(props as SliderAttributeProps)} />
        // case ATTRIBUTE_TYPES.TEXTAREA:
        //     return <TextAreaAttribute {...(props as TextAreaAttributeProps)} />
        // case ATTRIBUTE_TYPES.TOGGLE:
        //     return <ToggleButtonAttribute {...(props as ToggleButtonAttributeProps)} />
    }
}
